import React from 'react';
import PropTypes from 'prop-types';
import { pureRender } from 'epic-alt-utils/index';

@pureRender
class Copyright extends React.Component {
    static propTypes = {
        copyrights: PropTypes.array,
        newLineCopyrights: PropTypes.bool
    };

    render() {
        const copyrights = this.props.copyrights || [];
        const newLineCopyrights = this.props.newLineCopyrights || false;
        const currentYear = [new Date().getFullYear()];

        return (
            <div className="col-xs-12 col-md-12 col-lg-6 no-padding">
                <div className="copyright-paragraph">
                    {
                        copyrights.map((copyright, i) => {
                            let c = copyright;
                            c = c.replace(/\{YEAR\}/g, currentYear);

                            c = c.replace(/&copy;/g, '©');

                            if (newLineCopyrights) {
                                return (
                                    /* eslint-disable react/no-danger */
                                    <div className="text-color-nonactive" key={`copyright-${c}`} dangerouslySetInnerHTML={{ __html: c }} />
                                );
                            }

                            return (
                                <span className="text-color-nonactive" key={`copyright-${c}`}>{c}&nbsp;&nbsp;</span>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}

export default Copyright;



// WEBPACK FOOTER //
// ./app/scripts/components/copyright/Copyright.js